var _excluded = ["bold", "className"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../font-weights.css";
var withWeightModifiers = function withWeightModifiers(WrappedComponent) {
  var NewComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var bold = _ref.bold,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);
    var classList = className;
    if (bold) {
      classList = "".concat(classList, " ").concat(styles.primaryBold);
    }
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      ref: ref,
      className: classList
    }, props));
  });
  process.env.NODE_ENV !== "production" ? NewComponent.propTypes = {
    bold: PropTypes.bool,
    className: PropTypes.string
  } : void 0;
  NewComponent.defaultProps = {
    bold: false,
    className: ''
  };
  return NewComponent;
};
export default withWeightModifiers;